export const SERVICES_MUNICIPAUX_INITIAL_FORM = {
  nom_service: "",
  slug_service: "",
  categorie_service: "",
  type_service: "",
  parent_id: "",
  accroche_service: "",
  description_service: "",
  adresse_service: "",
  cp_service: "",
  ville_service: "",
  gps_service: "",
  tel_service: "",
  tel_secondaire: "",
  mail_service: "",
  website_service: "",
  autre_url_service: "",
  horaires_service: "",
  infos_complementaires: "",
  icone_service: "",
  ordre_affichage: 0,
  is_public: true,
  is_active: true,
};

export const SERVICE_TYPE_OPTIONS = [
  {
    value: "all",
    label: "Tous",
  },
  {
    value: "service",
    label: "Service",
  },
  {
    value: "equipement",
    label: "Équipement",
  },
  {
    value: "partenaire",
    label: "Partenaire",
  },
  {
    value: "archives",
    label: "Archives",
  },
];

export const SERVICE_FORM_TYPE_OPTIONS = [
  {
    value: "",
    label: "Non défini",
  },
  {
    value: "service",
    label: "Service municipal",
  },
  {
    value: "equipement",
    label: "Équipement",
  },
  {
    value: "partenaire",
    label: "Partenaire",
  },
  {
    value: "archives",
    label: "Archives",
  },
];

export const SERVICE_STATUS_OPTIONS = [
  {
    value: "all",
    label: "Tous",
  },
  {
    value: "active",
    label: "Actifs",
  },
  {
    value: "inactive",
    label: "Inactifs",
  },
];

export const SERVICE_PUBLIC_OPTIONS = [
  {
    value: "all",
    label: "Tous",
  },
  {
    value: "public",
    label: "Affichés",
  },
  {
    value: "hidden",
    label: "Masqués",
  },
];

export const SERVICE_GPS_OPTIONS = [
  {
    value: "all",
    label: "Tous",
  },
  {
    value: "yes",
    label: "Avec GPS",
  },
];

export const SERVICE_LIMIT_OPTIONS = [12, 24, 48, 96];

export const SERVICE_CATEGORY_SUGGESTIONS = [
  "Accueil",
  "Animation",
  "Culture",
  "Éducation",
  "Jeunesse",
  "Sport",
  "Solidarité",
  "Urbanisme",
  "État civil",
  "Police municipale",
  "Environnement",
  "Technique",
  "Vie associative",
  "Seniors",
];

export const SERVICE_ICON_SUGGESTIONS = [
  "FaCity",
  "FaUsers",
  "FaChild",
  "FaBookOpen",
  "FaTree",
  "FaHeart",
  "FaRunning",
  "FaSchool",
  "FaBuilding",
  "FaPhoneAlt",
];

export const SERVICES_MUNICIPAUX_FORM_HELPERS = [
  "Le nom du service est obligatoire.",
  "Le slug est généré automatiquement à partir du nom si vous ne le saisissez pas.",
  "La visibilité publique permet de préparer une fiche sans l’afficher immédiatement.",
  "Le champ GPS peut rester vide si le service n’a pas de localisation précise.",
];